import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { StyleRules } from "@material-ui/styles/withStyles";

export function createUseClasses(styles: (theme: Theme) => StyleRules) {
  return makeStyles((theme: Theme) => createStyles(styles(theme)));
}
